import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'
import ChangePasswordForm from 'forms/client/change-password'

const ChangePasswordModal = ({ onClose }) => (
  <Modal title={'Change Password'} onClose={onClose}>
    <div className="modal-body my-5">
      <ChangePasswordForm hideModal={onClose} />
    </div>
  </Modal>
)

ChangePasswordModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default ChangePasswordModal
